import React from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./thankyou.module.css";

export default function FeedbackThankYou() {
  const navigate = useNavigate();
  const location = useLocation();

  const text =
    location?.state?.text ??
    "Your feedback has been successfully submitted. We truly appreciate you taking the time to help us improve.";
  const btnText = location?.state?.btnText ?? "Submit Another";
  const showBtn = location?.state?.showBtn ?? true;
  const navigationLink = location?.state?.navLink ?? -1;

  return (
    <div className={styles.container}>
      {/* Success Icon */}
      <div className={styles.iconWrapper}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          fill="none"
          stroke="#FF7A59"
          strokeWidth="3"
          viewBox="0 0 24 24"
          className={styles.checkIcon}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* Headline */}
      <h1 className={styles.title}>Thank You!</h1>

      {/* Subtext */}
      <p className={styles.message}>{text}</p>

      {/* Action Buttons */}
      {showBtn && (
        <div className={styles.buttonGroup}>
          <Button
            className={styles.secondaryBtn}
            onClick={() => navigate(navigationLink)}
          >
            {btnText}
          </Button>
        </div>
      )}
    </div>
  );
}
